import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";

import {
  emptyString,
  customerSurveyLabels,
  FIRST_ARRAY_INDEX,
  EMPTY_ARRAY_LENGTH,
} from "../../../../constants";

/**
 * Shows customer name / email / order id on the first survey question only.
 */
const CustomerInfoCard = ({ questionArray, questionOrder, customerDetail }) => {
  if (
    !Array.isArray(questionArray) ||
    questionArray.length === EMPTY_ARRAY_LENGTH
  ) {
    return emptyString;
  }

  if (
    !customerDetail ||
    questionArray[FIRST_ARRAY_INDEX]?.questionOrder !== questionOrder
  ) {
    return emptyString;
  }

  return (
    <Row className="me-0">
      <Col className="d-flex justify-content-center">
        <Col md={3} className=" text-center mt-2 customer-info">
          <div className=" border pt-2 px-2 rounded">
            <p aria-label={customerSurveyLabels.CUSTOMER_NAME_ARIA}>
              <span className="fw-bold">{customerSurveyLabels.CUSTOMER_NAME}</span>
              {customerDetail.name}
            </p>
            <p aria-label={customerSurveyLabels.CUSTOMER_EMAIL_ARIA}>
              <span className="fw-bold">{customerSurveyLabels.EMAIL}</span>
              {customerDetail.email}
            </p>
            <p aria-label={customerSurveyLabels.CUSTOMER_ORDER_ID_ARIA}>
              <span className="fw-bold">{customerSurveyLabels.ORDER_ID}</span>
              {customerDetail.orderId}
            </p>
          </div>
        </Col>
      </Col>
    </Row>
  );
};

CustomerInfoCard.propTypes = {
  questionArray: PropTypes.array,
  questionOrder: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customerDetail: PropTypes.object,
};

export default CustomerInfoCard;
